export const MAX_RETRIES = 3
export const MAX_RETRIES_NORESPONSE = 2
export const STATUS_RETRY = [[500, 599]]
export const ERRORS_CODE_SIGNIN_PHONE = ['auth/too-many-requests']
export const METHODS_RETRY = ['GET', 'POST', 'HEAD', 'OPTIONS', 'DELETE', 'PUT']
